import search from '../../assets/icons/search.svg';

export default function SearchIcon({ className }: { className?: string }) {
  return (
    <img
      src={search}
      alt="Search Icon"
      className={className}
    />
  );
}
